import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment";
import {AutoComplete} from "primereact/autocomplete";
import ReactQuill from "react-quill";

const ProjectFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [companys, setCompanys] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [type, setType] = useState({});
  const [partners, setPartners] = useState([]);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [partnerQuery, setPartnerQuery] = useState(
    window.App.urlVars().partnerName ? decodeURIComponent(window.App.urlVars().partnerName) : ''
  );
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [projectLoaded, setProjectLoaded] = useState(false);

  const isEditMode = (id && id !== 'undefined') || window.App.urlVars().projectId;
  const canRenderForm = !isEditMode || projectLoaded;

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...newFormData,
      name: formData.name,
      currency: formData.currency,
    }
    if ((id && id !== 'undefined') || window.App.urlVars().projectId) {
      const projectId = (id && id !== 'undefined') ? id : window.App.urlVars().projectId;
      const projectTypeId = formData?.project_type?.id || type?.id || window.App.urlVars().projectTypeId || formData?.project_type;
      apiCall('patch', `/api/v2/project/${projectTypeId}/${projectId}`, payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderProjectList: Math.random(),
            rerenderProjectShow: Math.random(),
          })
          if (props.goback === true) {
            const ret = window.App.urlVars().return;
            history.push(ret ? decodeURIComponent(ret) : '/project');
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/project/' + window.App.urlVars().projectTypeId, data)
        .then(response => {
          setFormData(response.data.data)
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderProjectList: Math.random(),
            rerenderProjectShow: Math.random(),
          })
          if (props.goback === true) {
            history.push('/project/project/read/' + response.data.data.id);
          } else {
            history.push('/project/project/read/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  } 

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        'search[customer][operator]': '==',
        'search[customer][value]': 'true'
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code || partner.address_city || partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };

  useEffect(() => {
    if (window.App.urlVars().projectTypeId) {
      apiCall('GET', '/api/v2/project-type/' + window.App.urlVars().projectTypeId)
        .then(response => {
          setType(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.urlVars().projectTypeId])

  useEffect(() => {
    const partnerId = window.App.urlVars().partnerId;
    const partnerName = window.App.urlVars().partnerName;
    if (partnerId && partnerName) {
      setFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setNewFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setPartnerQuery(decodeURIComponent(partnerName));
    }
  }, [window.location.hash]);

  useEffect(() => {
    if (!((id && id !== 'undefined') || window.App.urlVars().projectId) && type?.name) {
      setFormData(prev => ({
        ...prev,
        name: prev.name || type.name
      }))
    }
  }, [type?.name, id])

  useEffect(() => {
    if (
      !((id && id !== 'undefined') || window.App.urlVars().projectId) &&
      formData?.project_type?.id &&
      !window.App.urlVars().formData
    ) {
      apiCall('GET', '/api/v2/project-type/' + formData.project_type.id)
        .then(response => {
          setType(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.project_type])

  useEffect(() => {
    if (window.App.urlVars().formData) {
      const decodedString = decodeURIComponent(window.App.urlVars().formData);
      const jsonData = JSON.parse(decodedString);
      setFormData(jsonData);
    }
  }, [window.App.urlVars().formData])

  useEffect(() => {
    // if (formData?.project_type?.id) {
    //   apiCall('GET', '/api/v2/project-type/' + formData.project_type.id)
    //     .then(response => {
    //       setType(response.data.data)
    //     })
    //     .catch(error => {
    //       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //     })
    // }
    // let _contractQuery = {
    //   rows: 9999,
    //   filters: {
    //     'project_type': {value: window.App.urlVars().projectTypeId, matchMode: 'equals'}
    //   }
    // }
    // let contractQuery = window.App.transformQueryParams(_contractQuery)
    // apiCall('GET', '/api/v2/contract' + contractQuery)
    //   .then(response => {
    //     setContracts(response.data.data.items)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //   })
    apiCall('GET', '/api/v2/project-status')
      .then(response => {
        setProjectStatuses(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/location?item_per_page=9999&sort=name&direction=asc')
      .then(response => {
        setLocations(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/company')
      .then(response => {
        setCompanys(response.data.data.items)
        if (response.data?.data?.items[0] && !window.App.urlVars().formData && !((id && id !== 'undefined') || window.App.urlVars().projectId)) {
          setFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }))
          setNewFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }))
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((id && id !== 'undefined') || window.App.urlVars().projectId) {
      setLoading(true);
      setProjectLoaded(false);
      const projectId = (id && id !== 'undefined') ? id : window.App.urlVars().projectId;
      apiCall('get', '/api/v2/project/' + projectId)
        .then(response => {
          const processedData = {
            ...response.data.data,
            location: response.data.data.location?.id || null,
            warehouse: response.data.data.warehouse?.id || null,
            company: response.data.data.company?.id || null,
            project_status: response.data.data.project_status?.id || response.data.data.project_status || null,
            contract: response.data.data.contract?.id || null,
            currency: response.data.data.currency || null,
          }
          setType(response.data.data.project_type || {});
          setFormData({
            ...processedData,
            partner: response.data.data.partner?.id || response.data.data.partner || null
          });
          setPartnerQuery(response.data.data.partner?.name || response.data.data.partnerName || '');
          setProjectLoaded(true);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setProjectLoaded(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [])

  useEffect(() => {
    const projectTypeId =
      window.App.urlVars().projectTypeId ||
      formData?.project_type?.id ||
      type?.id;
    if (!projectTypeId) {
      setContracts([]);
      return;
    }
    let _contractQuery = {
      rows: 9999,
      filters: {
        project_type: {value: projectTypeId, matchMode: 'equals'}
      }
    };
    let contractQuery = window.App.transformQueryParams(_contractQuery);
    apiCall('GET', '/api/v2/contract' + contractQuery)
      .then(response => {
        setContracts(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [formData?.project_type?.id, type?.id])

  // useEffect(() => {
  //   if (!(action === 'update') && currencies?.length && !formData.currency) {
  //     setFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
  //      setNewFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
  //   }
  // }, [currencies, entity, id, formData.currency]);

  useEffect(() => {
    if (
      !((id && id !== 'undefined') || window.App.urlVars().projectId) &&
      currencies?.length &&
      !formData.currency
    ) {
      setFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
      setNewFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
    }
  }, [currencies, id, formData.currency]);

  return (
    <div className={"project-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      {canRenderForm && (
      <Form onSubmit={onSubmit} initialValues={formData} enableReinitialize
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="company" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(companys, "name")}
                               id={"company"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCompanyYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   company: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   company: e.value
                                 })
                               }}
                               value={formData.company?.id || formData.company}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown 
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            currency: e.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            currency: e.value
                                          })
                                        }}
                                        value={formData.currency}
                                        options={window.App.sortDropdownOptions(currencies, "key")}
                                        optionLabel="key"
                                        optionValue="key"
                                        id={"currency"}
                                        emptyMessage={t('noCurrencyYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            
          {type.value_warranty_expiry_date !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="warranty_expiry_date" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="warranty_expiry_date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldWarrantyExpiryDate')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"warranty_expiry_date"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={moment.utc(formData.warranty_expiry_date || null).local().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       warranty_expiry_date: new Date(e.value)
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       warranty_expiry_date: new Date(e.value)
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.warranty_expiry_date}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    warranty_expiry_date: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    warranty_expiry_date: e.value
                                  })
                                }}/>
                    </div>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {type.project_status_directly_settable !== 'disabled' && (window.App.urlVars().projectId || (id && id !== 'undefined')) &&
              <div className={"p-col-12 p-lg-4"}>
                <Field name="project_status" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="project_status"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectStatus')}</label>
                    <span className={"p-d-block"}>
                              <Dropdown
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            project_status: e.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            project_status: e.value
                                          })
                                        }}
                                        value={formData.project_status}
                                        options={window.App.sortDropdownOptions(projectStatuses, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"project_status"}
                                        emptyMessage={t('noProjectStatusYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
          </div>
          <div className={"p-grid p-mt-1"}>
            {type.value_partner && type.value_partner !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"} id="partner_field">
                <Field name="partner" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="partner" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                    <span className={"p-field p-inputgroup"}>
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                let _params = '?';
                                Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                  _params += key + '=' + value + '&';
                                });
                                const current = window.location.hash.replace('#', '');
                                _params += 'backlink=' + encodeURIComponent(current) + '&';
                                _params += 'search=partner';
                                history.push(current + _params);
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete
                                    value={partnerQuery}
                                    id={"partner"}
                                    loading={partnerLoading}
                                    suggestions={partners}
                                    forceSelection
                                    completeMethod={searchPartner}
                                    field={"displayName"}
                                    delay={700}
                                    placeholder={t('typeToSearchPlaceholder')}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      const p = e.value;
                                      if (!p?.id) return;
                                      setPartnerQuery(p.displayName || p.name || '');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                      input.onChange(Number(p.id));
                                    }}
                                    onChange={(e) => {
                                      setPartnerQuery(e.value);
                                      if (!e.value || String(e.value).trim() === '') {
                                        setFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));

                                        setNewFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));

                                        input.onChange(null);
                                      }
                                    }}
                                    onClear={() => {
                                      setPartnerQuery('');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                      input.onChange(null);
                                    }}
                                  />
                              <Button type="button" className={"p-button"}
                                      onClick={() => {
                                      const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                      const params = new URLSearchParams();

                                      Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                        params.append(key, value);
                                      });

                                      params.set('backlink', currentPath);
                                      params.set('search', 'partner');

                                      history.push(`${currentPath}?${params.toString()}`);
                                    }}>
                                <i className={"pi pi-plus"}></i>
                              </Button>
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {type.value_contract && type.value_contract !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="contract" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="contract"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('contract')}</label>
                    <span className={"p-d-block"}>
                              <Dropdown
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            contract: e.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            contract: e.value
                                          })
                                        }}
                                        value={formData.contract}
                                        options={window.App.sortDropdownOptions(contracts, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"contract"}
                                        emptyMessage={t('noContractYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {type.value_deadline && type.value_deadline !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="deadline" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="deadline"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDeadline')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"deadline"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={formData.deadline ? moment.utc(formData.deadline).local().format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       deadline: new Date(e.value)
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       deadline: new Date(e.value)
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.deadline}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    deadline: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    deadline: e.value
                                  })
                                }}/>
                    </div>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {type.value_external_id && type.value_external_id !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="external_id" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="external_id"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('externalReference')}</label>
                    <span className="p-d-block">
                      <InputText id="external_id" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     external_id: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     external_id: e.target.value
                                   })
                                 }}
                                 value={formData.external_id}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {type.value_location && type.value_location !== 'disabled' &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="location" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="location"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLocation')}</label>
                    <span className={"p-d-block"}>
                              <Dropdown 
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            location: e.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            location: e.value
                                          })
                                        }}
                                        value={formData.location}
                                        options={window.App.sortDropdownOptions(locations, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"location"}
                                        filter
                                        emptyMessage={t('noLocationYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            <div className={"p-col-12 p-lg-12"}>
                          <Field name="note" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <label htmlFor="note"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                                  <div id={"editor-container"}>
                                  <ReactQuill id="note" {...input}
                                              modules={{toolbar: toolbarOptions}}
                                              onChange={(value) => {
                                               setFormData({
                                                 ...formData,
                                                 note: value
                                               })
                                               setNewFormData({
                                                 ...newFormData,
                                                 note: value
                                               })
                                             }}
                                             value={formData.note}
                                             className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                                  </div>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
            {/*{type.value_milestone && type.value_milestone !== 'disabled' &&*/}
            {/*  <div className={"p-col-12 p-lg-6"}>*/}
            {/*    <Field name="milestone" render={({input, meta}) => (*/}
            {/*      <div className="p-field p-fluid">*/}
            {/*        <label htmlFor="milestone"*/}
            {/*               className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMilestone')}</label>*/}
            {/*        <span className={"p-d-block"}>*/}
            {/*                  <Dropdown {...input}*/}
            {/*                            onChange={(e) => {*/}
            {/*                              setFormData({*/}
            {/*                                ...formData,*/}
            {/*                                milestone: e.target.value*/}
            {/*                              })*/}
            {/*                              setNewFormData({*/}
            {/*                                ...newFormData,*/}
            {/*                                milestone: e.target.value*/}
            {/*                              })*/}
            {/*                            }}*/}
            {/*                            value={formData.milestone}*/}
            {/*                            options={window.App.sortDropdownOptions(milestones, "name")}*/}
            {/*                            optionLabel="name"*/}
            {/*                            optionValue="id"*/}
            {/*                            id={"milestone"}*/}
            {/*                            emptyMessage={t('noMilestoneYet')}*/}
            {/*                            className={classNames({'p-error': isFormFieldValid(meta)})}*/}
            {/*                  />*/}
            {/*                </span>*/}
            {/*        {getFormErrorMessage(meta)}*/}
            {/*      </div>*/}
            {/*    )}/>*/}
            {/*  </div>*/}
            {/*}*/}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'project' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
      )}
    </div>
  )
}
export default withTranslation('common')(ProjectFormComponent);
